import { m8API } from 'services/production/m8';

export const createDemoStack = async () => {
  return m8API.user.createDemoStackClaim();
};
